import { LockKeyhole, LogIn } from 'lucide-react';

function AuthInteractionGate({ authenticated, onSignIn, children, label = 'Sign in to use this feature' }) {
  if (authenticated) return children;

  return (
    <div className="auth-interaction-gate">
      <fieldset className="auth-interaction-gate-content" aria-hidden="true" disabled>
        {children}
      </fieldset>
      <div className="auth-interaction-gate-prompt" role="region" aria-label="Authentication required">
        <span><LockKeyhole size={18} /></span>
        <div>
          <strong>{label}</strong>
          <small>You can explore the application, but creating or uploading content requires an account.</small>
        </div>
        <button type="button" className="primary-button" onClick={onSignIn}>
          <LogIn size={16} /> Sign in
        </button>
      </div>
    </div>
  );
}

export default AuthInteractionGate;
